import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import {
  RegionalPartnerMiniContact,
  RegionalPartnerMiniContactPopupLink,
} from '@cdo/apps/code-studio/pd/regional_partner_mini_contact/RegionalPartnerMiniContact';
import {queryParams} from '@cdo/apps/code-studio/utils';

window.showRegionalPartnerMiniContact = function () {
  const regionalPartnerMiniContactElement = $(
    '#regional-partner-mini-contact-container'
  );
  const sourcePageId = regionalPartnerMiniContactElement.data('source-page-id');
  let options = {};
  const zipFromUrlParams = queryParams()['zip'];

  $.ajax({
    type: 'GET',
    url: '/dashboardapi/v1/users/me/contact_details',
  })
    .done(results => {
      options = {
        user_name: results.user_name,
        email: results.email,
        zip: zipFromUrlParams || results.zip,
      };
    })
    .complete(() => {
      ReactDOM.render(
        <RegionalPartnerMiniContact
          options={options}
          apiEndpoint="/dashboardapi/v1/pd/regional_partner_mini_contacts/"
          sourcePageId={sourcePageId}
        />,
        regionalPartnerMiniContactElement[0]
      );
    });
};

window.showRegionalPartnerMiniContactPopupLink = function () {
  const regionalPartnerMiniContactPopupLinkElement = $(
    '#regional-partner-mini-contact-popup-link-container'
  );

  const sourcePageId =
    regionalPartnerMiniContactPopupLinkElement.data('source-page-id');
  const linkText = regionalPartnerMiniContactPopupLinkElement.data('link-text');
  const isButton =
    regionalPartnerMiniContactPopupLinkElement.data('link-button');

  ReactDOM.render(
    <RegionalPartnerMiniContactPopupLink sourcePageId={sourcePageId}>
      {isButton && <button type="button">{linkText}</button>}
      {!isButton && linkText}
    </RegionalPartnerMiniContactPopupLink>,
    regionalPartnerMiniContactPopupLinkElement[0]
  );
};
